export default __webpack_public_path__ + "static/media/modern-ux-with-react-server-components.7e14fef6.jpg";